module.exports = __webpack_public_path__ + "static/img/596_phase_function_Paper_PointsHejduk_Prediction.f244b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/596_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nr9c
// module chunks = 0